import { EducationHubCategory } from '../dao/core-dao'
import { coreService } from '../service/core-service'
import { UseQueryResult, useQuery } from '@tanstack/react-query'
import { queryKeys } from 'src/util/query-keys'

export const useEducationHubCategories = (): UseQueryResult<EducationHubCategory, Error> => {
  return useQuery<EducationHubCategory, Error>(queryKeys.educationHubCategories(), () => coreService.listEducationHubCategories())
}
